import { Tabs } from "@xola/ui-kit";
import clsx from "clsx";
import React, { useState } from "react";
import { Button, ButtonType, CheckoutType, Permission, PopupCheckoutType } from "types";
import { ButtonCodeHeading } from "../ButtonCodeHeading";
import { ButtonList } from "../ButtonList";
import { ProductButtonList } from "../ProductButtonList";
import { useSeller } from "@/hooks/useAccount";
import { useAuthorization } from "@/hooks/useAuthorization";
import { useInfiniteCollection } from "@/hooks/useInfiniteCollection";
import { hasX2CheckoutWithFullProbability, isPurchaseItemizationEnabled } from "@/models/Seller";

interface ButtonCodeSectionProps {
    checkoutType: CheckoutType;
    popupType: PopupCheckoutType;
}

export const StepFourButtonCodeSection = ({ checkoutType, popupType }: ButtonCodeSectionProps) => {
    const seller = useSeller();
    const { isGranted } = useAuthorization();
    const [activeTab, setActiveTab] = useState(0);

    const isNotItemized = !isPurchaseItemizationEnabled(seller);
    const number = checkoutType === CheckoutType.URL || hasX2CheckoutWithFullProbability() ? 3 : 4;

    // Pre-fetch buttons for all types so they are ready when the user clicks on the tab. Otherwise feels slow
    useInfiniteCollection<Button>("buttons", { type: ButtonType.CHECKOUT }, { enabled: isNotItemized });
    useInfiniteCollection<Button>("buttons", { type: ButtonType.TIMELINE });
    useInfiniteCollection<Button>("buttons", { type: ButtonType.GIFT });

    return (
        <div className="space-y-4 py-8">
            <ButtonCodeHeading number={number}>Copy + Paste button code</ButtonCodeHeading>
            <Tabs className="!mt-8 w-full" value={activeTab} onChange={(value: number) => setActiveTab(value)}>
                <Tabs.Tab>Single Item Checkout</Tabs.Tab>
                <Tabs.Panel>
                    <ProductButtonList checkoutType={checkoutType} popupType={popupType} />
                </Tabs.Panel>
                <Tabs.Tab className={clsx(isNotItemized ? "visible" : "hidden")}>Multiple Item Checkout</Tabs.Tab>
                <Tabs.Panel>
                    {isNotItemized ? (
                        <ButtonList type={ButtonType.CHECKOUT} checkoutType={checkoutType} popupType={popupType} />
                    ) : null}
                </Tabs.Panel>
                <Tabs.Tab>Timeline</Tabs.Tab>
                <Tabs.Panel>
                    <ButtonList type={ButtonType.TIMELINE} checkoutType={checkoutType} popupType={popupType} />
                </Tabs.Panel>
                <Tabs.Tab isHidden={!isGranted(Permission.GIFT_OFFERS_VIEW)}>Gifts</Tabs.Tab>
                <Tabs.Panel>
                    <ButtonList type={ButtonType.GIFT} checkoutType={checkoutType} popupType={popupType} />
                </Tabs.Panel>
            </Tabs>
        </div>
    );
};
